import { DialogsOpenStatuses } from '../../data-types/dialogs/dialogInterfaces';
import { SignupCheckpoint, SignupInfo } from '../../data-types/signup/signupInterfaces';
import { ResetState } from './stateTypes';

export type SignupActionType =
  | ResetState
  | SetInitialSignUpLoad
  | SetCurrentSignUpPath
  | SetSignupChoiceDialogOpen
  | SetZimplerSignupDialogOpen
  | SetSignUpDialogOpen
  | SetUseSignupV3
  | SetSignupCheckpoint
  | SetIsAfterZimplerSignup
  | SetHasJustSignedUp;

export const SET_INITIAL_SIGNUP_LOAD = 'SET_INITIAL_SIGNUP_LOAD';
export const SET_CURRENT_SIGNUP_PATH = 'SET_CURRENT_SIGNUP_PATH';
export const SET_SIGNUP_CHOICE_DIALOG_OPEN = 'SET_SIGNUP_CHOICE_DIALOG_OPEN';
export const SET_ZIMPLER_SIGNUP_DIALOG_OPEN = 'SET_ZIMPLER_SIGNUP_DIALOG_OPEN';
export const SET_SIGNUP_DIALOG_OPEN = 'SET_SIGNUP_DIALOG_OPEN';
export const SET_USE_SIGNUP_V3 = 'SET_USE_SIGNUP_V3';
export const SET_SIGNUP_CHECKPOINT = 'SET_SIGNUP_CHECKPOINT';
export const SET_IS_AFTER_ZIMPLER_SIGN_UP = 'SET_IS_AFTER_ZIMPLER_SIGN_UP';
export const SET_HAS_JUST_SIGNED_UP = 'SET_HAS_JUST_SIGNED_UP';

export interface SignupState {
  initialSignUpLoad: boolean;
  currentSignUpPath: string;
  signupV3: SignupInfo;
  dialogs: DialogsOpenStatuses;
  isAfterZimplerSignup: boolean;
  hasJustSignedUp: boolean;
}

interface SetInitialSignUpLoad {
  type: typeof SET_INITIAL_SIGNUP_LOAD;
  meta: boolean;
}

interface SetCurrentSignUpPath {
  type: typeof SET_CURRENT_SIGNUP_PATH;
  meta: string;
}

interface SetSignupChoiceDialogOpen {
  type: typeof SET_SIGNUP_CHOICE_DIALOG_OPEN;
  meta: boolean;
}

interface SetZimplerSignupDialogOpen {
  type: typeof SET_ZIMPLER_SIGNUP_DIALOG_OPEN;
  meta: boolean;
}

interface SetSignUpDialogOpen {
  type: typeof SET_SIGNUP_DIALOG_OPEN;
  meta: boolean;
}

interface SetUseSignupV3 {
  type: typeof SET_USE_SIGNUP_V3;
  meta: boolean;
}

interface SetSignupCheckpoint {
  type: typeof SET_SIGNUP_CHECKPOINT;
  meta: SignupCheckpoint | undefined;
}

interface SetIsAfterZimplerSignup {
  type: typeof SET_IS_AFTER_ZIMPLER_SIGN_UP;
  meta: boolean;
}

interface SetHasJustSignedUp {
  type: typeof SET_HAS_JUST_SIGNED_UP;
  meta: boolean;
}
